import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { upsertAgency } from "../../../actions/agency";
import { clearMessage, setMessage } from "../../../actions/message";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Switch from "@mui/material/Switch";
import { Grid, Input, MenuItem, Select, InputLabel } from "@mui/material";
import { Divider, Button } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import CountrySelect from "../../../CountrySelect";
import InputAdornment from "@mui/material/InputAdornment";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Typeahead } from "react-bootstrap-typeahead";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { IconButton } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PeopleIcon from '@mui/icons-material/People';
import InfoIcon from '@mui/icons-material/Info';
import TabPanel from "../../../TabPanel";
import { Typography } from "@mui/material";
import { getUsers } from "../../../actions/user";
import { DataGrid } from "@mui/x-data-grid";

const AgencyModal = (props) => {
  const dispatch = useDispatch();
  const form = useRef();
  const checkBtn = useRef();

  const [Name, setName] = useState("");
  const [Address, setAddress] = useState("");
  const [Address2, setAddress2] = useState("");
  const [Locality, setLocality] = useState("");
  const [Zipcode, setZipcode] = useState("");
  const [country, setCountry] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [Email, setEmail] = useState("");
  const [active, setActive] = useState(true);
  const [commissionType, setCommissionType] = useState(0);
  const [commissionPercentage, setCommissionPercentage] = useState(0);
  const [vatNumber, setVatNumber] = useState("");
  const [price_per_week, setPricePerWeek] = useState(0);
  const [discount_per_week, setDiscountPerWeek] = useState(0);
  const [currency, setCurrency] = useState(0);

  const [loading, setLoading] = useState(false);
  const { message } = useSelector((state) => state.message);

  const { agencies: listAgencies } = useSelector((state) => state.agencies);
  const { users: listUsers } = useSelector((state) => state.users);
  const [loaded, setLoaded] = useState(false);
  const [agencyUsers, setAgencyUsers] = useState([]);
  const [tabValue, setTabValue] = React.useState(0);
  const tabPanelHeight = 400;
  useEffect(() => {

    if (props.show && props.current_agency != null && !loaded) {

      if (!listUsers) dispatch(getUsers());

      listAgencies
        .filter((agency) => {
          return agency.id === props.current_agency.id;
        }).map(
          (agency) => (
            setName(agency.name),
            setActive(agency.active),
            setAddress(agency.adress),
            setAddress2(agency.adress2),
            setLocality(agency.locality),
            setZipcode(agency.zipcode),
            setActive(agency.active),
            setPhoneNumber(agency.phoneNumber),
            setCommissionType(agency.commissionType),
            setCommissionPercentage(agency.commissionPercentage),
            setVatNumber(agency.vatNumber),
            setAgencyUsers(agency.users),
            setEmail(agency.email),
            setPricePerWeek(agency.pricePerWeek),
            setCurrency(agency.currency),
            setCountry(agency.country),
            setDiscountPerWeek(agency.discountPerWeek)
          )
        );
      setLoaded(true);
    }
    if (!props.show && props.current_agency) {
      clearUI();
      setLoaded(false);
    }
  });

  const columns = [
    { field: 'firstName', headerName: 'Firstname' },
    { field: 'lastName', headerName: 'Lastname' },
    { field: 'email', headerName: 'Email address', flex: 1 }
  ];

  const clearUI = () => {
    setName("");
    setAddress("");
    setAddress2("");
    setLocality("");
    setZipcode("");
    setPhoneNumber("");
    setEmail("");
    setActive(false);
    setLoading(false);
    setCommissionType(0);
    setCommissionPercentage(0);
    setVatNumber("");
    setAgencyUsers([]);
    setPricePerWeek(0);
    setCurrency(0);
    setDiscountPerWeek(0);
    props.updateSelectedAgency(null);
  };

  const handleCommissionTypeChange = (ct) => {
    if (ct == 1) setCommissionPercentage(0);
    setCommissionType(ct);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      let agency_tmp = {};

      if (props.current_agency != null) {
        agency_tmp = props.current_agency;
      }

      agency_tmp.name = Name;
      agency_tmp.active = active;
      agency_tmp.adress = Address;
      agency_tmp.adress2 = Address2;
      agency_tmp.locality = Locality;
      agency_tmp.zipcode = Zipcode;
      agency_tmp.phoneNumber = PhoneNumber;
      agency_tmp.email = Email;
      agency_tmp.commissionType = commissionType;
      agency_tmp.commissionPercentage = commissionPercentage;
      agency_tmp.vatNumber = vatNumber;
      agency_tmp.users = agencyUsers;
      agency_tmp.PricePerWeek = price_per_week;
      agency_tmp.currency = currency;
      agency_tmp.discountPerWeek = discount_per_week;
      agency_tmp.country = country;
      dispatch(upsertAgency(agency_tmp))
        .then(() => {
          toast.success(
            `Agency ${agency_tmp.id > 0 ? "updated" : "created"} successfuly`,
            { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
          );
          props.onHide();
        })
        .catch(() => {
          toast.error(
            `An Error occured while updating the agency. Try again later.`,
            { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
          );
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Modal {...props} size="xl" centered>
      <Form onSubmit={handleSubmit} ref={form}>
        <Modal.Header closeButton>
          <Grid container>
            <Grid item>
              <Modal.Title>Edit Agency</Modal.Title>
            </Grid>
          </Grid>
          <FormControlLabel
            control={
              <Switch
                checked={active}
                onChange={(e) => setActive(e.target.checked)}
              />
            }
          />
        </Modal.Header>

        <Modal.Body>
          <Grid container spacing={1}>

            <Grid item xs={12}>
              <Tabs value={tabValue} onChange={handleTabChange}>
                <Tab icon={<InfoIcon />} aria-label="info" />
                <Tab icon={<PeopleIcon />} aria-label="people" />
              </Tabs>
              <TabPanel value={tabValue} index={0} height={tabPanelHeight}>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <label htmlFor="name">Agency name</label>
                    <Input
                      type="text"
                      className="form-control"
                      name="name"
                      size="small"
                      value={Name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </Grid>


                  <Grid item xs={6}>
                    <label htmlFor="phonenumber">Phone Number</label>
                    <Input
                      type="text"
                      className="form-control"
                      name="phonenumber"
                      size="small"
                      value={PhoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <label htmlFor="email">Email address</label>
                    <Input
                      type="text"
                      className="form-control"
                      name="email"
                      size="small"
                      value={Email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <label htmlFor="email">VAT Number</label>
                    <Input
                      type="text"
                      className="form-control"
                      name="vat"
                      size="small"
                      value={vatNumber}
                      onChange={(e) => setVatNumber(e.target.value)}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <label htmlFor="address">Address</label>
                    <Input
                      type="text"
                      className="form-control"
                      name="address"
                      size="small"
                      value={Address}
                      onChange={(e) => setAddress(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <label htmlFor="address2">Address complement</label>
                    <Input
                      type="text"
                      className="form-control"
                      name="adress2"
                      size="small"
                      value={Address2}
                      onChange={(e) => setAddress2(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <label htmlFor="email">Locality</label>
                    <Input
                      type="text"
                      className="form-control"
                      name="locality"
                      size="small"
                      value={Locality}
                      onChange={(e) => setLocality(e.target.value)}
                    />
                  </Grid>

                  <Grid item xs={3}>
                    <label htmlFor="email">Zipcode</label>
                    <Input
                      type="text"
                      className="form-control"
                      name="locality"
                      size="small"
                      value={Zipcode}
                      onChange={(e) => setZipcode(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <label htmlFor="country">Country</label>
                    <CountrySelect setValue={setCountry} selectedCode={country} />
                  </Grid>

                  <Grid item xs={2}>
                    <label htmlFor="discountperweek">Discount per week</label>
                    <Input
                      type="number"
                      className="form-control"
                      name="discountperweek"
                      size="small"
                      value={discount_per_week}
                      onChange={(e) => setDiscountPerWeek(e.target.value)}
                      endAdornment={
                        <InputAdornment position="end">%</InputAdornment>
                      }
                    />
                  </Grid>

                  <Grid item xs={2}>
                    <label htmlFor="type">Commission Type</label>
                    <Select
                      size="small"
                      style={{ minWidth: "100%" }}
                      value={commissionType}
                      onChange={(e) => handleCommissionTypeChange(e.target.value)}
                    >
                      <MenuItem value={1}>None</MenuItem>
                      <MenuItem value={2}>Pre commission</MenuItem>
                      <MenuItem value={3}>Post commission</MenuItem>
                      <MenuItem value={4}>Special Price</MenuItem>
                    </Select>
                  </Grid>

                  {commissionType == 2 || commissionType == 3 ? (
                    <Grid item xs={3}>
                      <label htmlFor="percentage">Commission Percentage</label>
                      <Input
                        type="number"
                        className="form-control"
                        name="percentage"
                        size="small"
                        value={commissionPercentage}
                        onChange={(e) => setCommissionPercentage(e.target.value)}
                        endAdornment={
                          <InputAdornment position="end">%</InputAdornment>
                        }
                      />
                    </Grid>
                  ) : (
                    commissionType != 1 ?
                      <>
                        <Grid item xs={2}>
                          <label htmlFor="priceperweek">Price per week</label>
                          <Input
                            type="number"
                            className="form-control"
                            name="priceperweek"
                            size="small"
                            value={price_per_week}
                            onChange={(e) => setPricePerWeek(e.target.value)}
                          />
                        </Grid>
                        <Grid item xs={1}>
                          <label htmlFor="currency">Currency</label>
                          <Select size="small" style={{ minWidth: '100%' }} value={currency || 0} onChange={(e) => setCurrency(e.target.value)}>
                            <MenuItem value={1}>€</MenuItem>
                            <MenuItem value={2}>£</MenuItem>
                            <MenuItem value={3}>$</MenuItem>
                          </Select>
                        </Grid>
                      </>
                      :
                      <></>
                  )}
                </Grid>
              </TabPanel>
              <TabPanel value={tabValue} index={1} height={tabPanelHeight}>
                <Grid item xs={12} container sx={{ height: 350 }}>
                  <div style={{ height: 350, width: '100%' }}>
                    <label>Agents</label>
                    <DataGrid
                      rows={agencyUsers}
                      columns={columns} />
                  </div>
                </Grid>
              </TabPanel>
            </Grid>

            <CheckButton style={{ display: "none" }} ref={checkBtn} />
          </Grid>
        </Modal.Body>

        <Modal.Footer>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Button variant="outlined" onClick={props.onHide} sx={{ width: '100%' }}>Close</Button>
            </Grid>
            <Grid item xs={6}>
              <Button variant="contained" onClick={handleSubmit} sx={{ width: '100%' }}>
                Save
              </Button>
            </Grid>
          </Grid>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AgencyModal;
